// extracted by mini-css-extract-plugin
export var dataCell = "_ju-2";
export var dataRow = "_ju-0";
export var headerRow = "_ju-1";